
function initStickyClone() {
  const originalBtn = document.querySelector('.primary-btn');
  const firebloodBtn = document.querySelector('.fireblood-bottom-area');
  const introSection = document.querySelector('.intro-section-fireblood');

  if (!originalBtn || !firebloodBtn || !introSection) {
    setTimeout(initStickyClone, 100);
    return;
  }

  if (document.getElementById('sticky-clone')) return;

  const clone = originalBtn.cloneNode(true);
  clone.id = "sticky-clone";
  document.body.appendChild(clone);

  let lastScrollY = window.scrollY;
  let scrollDirection = 'down'; // lock state

  function handleScroll() {
    const rect = introSection.getBoundingClientRect();
    const sectionHeight = rect.height;

    const isMobile = window.innerWidth < 768;
    const triggerPercent = isMobile ? 1 : 0.9;
    const triggerPoint = sectionHeight * triggerPercent;

    const currentScrollY = window.scrollY;
    const delta = currentScrollY - lastScrollY;

    // 👇 Only update direction if movement is meaningful
    if (Math.abs(delta) > 10) {
      scrollDirection = delta > 0 ? 'down' : 'up';
      lastScrollY = currentScrollY;
    }

    if (rect.top <= -triggerPoint) {
      clone.classList.add('show');
      firebloodBtn.classList.add('show');

      if (scrollDirection === 'up') {
        clone.classList.add('scroll-up');
        firebloodBtn.classList.add('scroll-up');
      } else {
        clone.classList.remove('scroll-up');
        firebloodBtn.classList.remove('scroll-up');
      }

    } else {
      clone.classList.remove('show', 'scroll-up');
      firebloodBtn.classList.remove('show', 'scroll-up');
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
}

initStickyClone();